/**
 * Destructive actions reuse the `primary_inverted` variant for its border/pill shape, but cancel
 * out its teal hover fill (see buttonVariants) - a red-bordered Reject/Delete button hovering
 * teal reads as a positive/confirm action, not a destructive one. Border and label stay red in
 * both idle and hover state, matching the flat (no hover colour shift) treatment already used
 * for the other destructive button in BatchOverviewModal (bg-aux-lightred hover:bg-aux-lightred).
 */
export const DESTRUCTIVE_IDLE_CLASS =
  'border-error-darkred text-error-darkred hover:bg-white hover:text-error-darkred';
